import AuthHeaderManager from "@roman/shared/lib/auth/AuthHeaderManager";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { RoundDetails } from "@roman/shared/types/RoundDetails";
import useSWR, { type SWRConfiguration } from "swr";
import type { Language, LanguageQuery } from "../../types/Language";

export interface RoundResponse {
  round: RoundDetails;
}

const fetcher = (url: string, lang: Language) => {
  const headers = AuthHeaderManager.getInstance().getAuthorizationHeader();
  return romanApi.get<RoundResponse, LanguageQuery>(url, { lang }, { headers });
};

interface UseSoccerRoundProps {
  roundId: string | null;
  lang?: Language;
  swrOptions?: SWRConfiguration;
}

export const useSoccerRound = ({ roundId, lang = "en", swrOptions }: UseSoccerRoundProps) => {
  const queryKey = roundId ? [`/soccer/rounds/${roundId}/`, lang] : null;

  const swrQuery = useSWR<RoundResponse, RomanApiError>(
    queryKey,
    ([url, lang]: [string, Language]) => fetcher(url, lang),
    swrOptions,
  );

  const homePlayers = swrQuery.data?.round.players.homePlayers ?? [];

  const awayPlayers = swrQuery.data?.round.players.awayPlayers ?? [];

  return {
    ...swrQuery,
    data: swrQuery.data
      ? {
          round: {
            ...swrQuery.data.round,
            players: { homePlayers, awayPlayers },
          },
        }
      : undefined,
  };
};
